import React, { type SyntheticEvent, useState } from 'react';
import { styled } from '@compiled/react';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import ModalDialog, {
	ModalBody,
	ModalTransition,
	ModalHeader,
	ModalTitle,
} from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { MODAL, ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { serviceDeskContextResource } from '@atlassian/jira-router-resources-service-desk-context/src/services/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import Body from './body';
import Footer from './footer';
import type { UseServiceDeskContextResource, KbLinkProps } from './types';

const KbLink = ({ name, link, iframeSrc, editLink, shareable }: KbLinkProps) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { data }: UseServiceDeskContextResource = useResource(serviceDeskContextResource);

	const onClick = (e: SyntheticEvent) => {
		e.preventDefault();
		setIsOpen(true);
	};
	if (!data) {
		return <Spinner size="small" />;
	}

	return (
		<>
			<Link href={`${data?.customerUrl}/${link}`} onClick={(e: SyntheticEvent) => onClick(e)}>
				<LinkInnerWrapper>
					<span>{name}</span>
					{!shareable && (
						<LockFilledIcon primaryColor={token('color.icon.danger', colors.R300)} label="" />
					)}
				</LinkInnerWrapper>
			</Link>
			<ContextualAnalyticsData sourceType={MODAL} sourceName="test">
				<ModalTransition>
					{isOpen && (
						<ShortcutScope>
							<ModalDialog width="x-large" onClose={() => setIsOpen(!isOpen)} height="100%">
								<ModalHeader>
									<ModalTitle>{name}</ModalTitle>
								</ModalHeader>
								<ModalBody>
									<Body name={name} src={iframeSrc} />
								</ModalBody>
								<Footer
									editLink={editLink}
									link={`${data?.customerUrl}/${link}`}
									onCancel={() => setIsOpen(false)}
								/>
							</ModalDialog>
						</ShortcutScope>
					)}
				</ModalTransition>
			</ContextualAnalyticsData>
		</>
	);
};

export default KbLink;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkInnerWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});
